module.exports = function _isNumber(x) {
  return Object.prototype.toString.call(x) === '[object Number]';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ramdasauce/~/ramda/src/internal/_isNumber.js
 ** module id = 352
 ** module chunks = 0
 **/